module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/reward-tiers/percent-8a1b509fb38b7cf7c1de7aa8dd308cd3.svg";